import wasmUrl from "@lottiefiles/dotlottie-web/dotlottie-player.wasm?url"

type PlayerModule = typeof import("@lottiefiles/dotlottie-web")

let playerModule: Promise<PlayerModule> | null = null

// Serves the player's wasm from our own CDN. The library's default points at jsdelivr, which
// otherwise sits in the render path of every animation on the page.
export const loadPlayer = () => {
  playerModule ||= import("@lottiefiles/dotlottie-web").then(module => {
    module.DotLottieWorker.setWasmUrl(wasmUrl)
    return module
  })

  return playerModule
}
